import PropTypes from 'prop-types'
import { getComponentData } from '../../../utils/getPageData'

import Process from '../../Process'
import MemberQuotes from '../../payoff-loan/Quotes'
import CTABlock from '../../payoff-loan/CTABlock'
import Hero from './Hero'
import Ratings from '../../dm-hm/Ratings'
import Benefits from '../../dm-hm/Benefits'
import Quote from '../../dm-hm/Quote'

const NonAPILandingHM = (props) => {
  const { payoffLoanData, data, defaultData, checkMyRateHref } = props

  const ratings = getComponentData({
    data,
    key: 'ratings',
    useSlice: true
  }).items

  const extraMemberQuotes = getComponentData({
    data,
    key: 'member_quotes',
    useSlice: true
  })

  const processHeadline = getComponentData({
    data,
    key: 'process',
    useSlice: true
  }).primary.headline

  return (
    <>
      <Hero
        data={getComponentData({
          data,
          key: 'hero',
          useSlice: true
        }).primary}
        ctaHref={checkMyRateHref}
      />

      <Benefits
        data={getComponentData({
          data,
          key: 'benefits',
          useSlice: true
        })}
        defaultData={getComponentData({
          data: defaultData,
          key: 'benefits',
          useSlice: true
        })}
        ctaHref={checkMyRateHref}
      />

      <Quote
        data={getComponentData({
          data,
          key: 'quote',
          useSlice: true
        }).primary}
        defaultData={getComponentData({
          data: defaultData,
          key: 'quote',
          useSlice: true
        }).primary}
      />
      {ratings && <Ratings data={ratings} />}

      <Process
        data={getComponentData({
          data: defaultData,
          key: 'process',
          useSlice: true
        })}
        processHeadline={processHeadline}
        ctaHref={checkMyRateHref}
      />
      {extraMemberQuotes && <MemberQuotes
        data={getComponentData({
          data: payoffLoanData,
          key: 'quotes',
        })}
        extra={extraMemberQuotes}
      />}
      <CTABlock
        data={getComponentData({
          data: payoffLoanData,
          key: 'cta',
        })}
        ctaHref={checkMyRateHref}
      />
    </>

  )
}

NonAPILandingHM.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  defaultData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  payoffLoanData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  checkMyRateHref: PropTypes.string.isRequired,
}

export default NonAPILandingHM
